// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  apiUrl: 'https://cadgrafics.escritoriodeayuda.com/api',
  googleClientId:
    '606336846716-4ecbgeabaku117grf3q32fnfq5ai51u2.apps.googleusercontent.com',
  pusherWsBroadcast: {
    broadcaster: 'pusher',
    key: 'WsM3s4d34yud4Br04dc4stk3y',
    cluster: 'mt1',
    wsHost: 'cadgrafics.escritoriodeayuda.com' ?? window.location.hostname,
    wsPort: 6001,
    authEndpoint: 'https://cadgrafics.escritoriodeayuda.com/api/broadcasting/auth',
    forceTLS: false,
    disableStats: true,
    encrypted: true,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
